import { createSelector } from '@ngrx/store';
import { AppState, PayformState } from '../app.state';

export const selectPayform = (state: AppState) => state.payform;

export const payformStateSelector = createSelector(selectPayform, (state: PayformState) => state);

export const payformReadOnlySelector = createSelector(selectPayform, (state: PayformState) => state.readOnly);

export const currentPayformSelector = createSelector(selectPayform, (state: PayformState) => state.current);

export const currentPayformNoteSelector = createSelector(selectPayform, (state: PayformState) => state.current.note);

export const currentPayformActivitySelector = createSelector(selectPayform, (state: PayformState) => state.current.dsrActivity);

export const linehaulScheduleSelector = createSelector(selectPayform, (state: PayformState) => state.current.linehaulSchedule);
